
import { AuthGuard } from '@guards/auth.guard';
import { LayoutComponent } from '@layout/layout.component';
import { PreloginLayoutComponent } from '@layout/prelogin-layout/prelogin-layout.component';
import { PathMatch } from '@model/common-type';
import { Routes } from "@angular/router";

export const mobileRoutes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: 'm', pathMatch: 'full' as PathMatch },
            {
                path: 'm',
                loadChildren: () => import('@modules/mailbox/mailbox.mobile.module').then(m => m.MailboxMobileModule)
            },
            {
                path: 'a',
                loadChildren: () => import('@modules/contact/contact.mobile.module').then(m => m.ContactMobileModule)
            },
            {
                path: 'settings',
                loadChildren: () => import('@modules/settings/settings.module').then(m => m.SettingsModule)
            },
            {
                path: 'c',
                loadChildren: () => import('@modules/calendar/calendar.mobile.module').then(m => m.CalendarMobileModule)
            }
        ]
    },
    {
        path: '', component: PreloginLayoutComponent, children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' as PathMatch },
            {
                path: 'login',
                loadChildren: () => import('@modules/login/login.module').then(m => m.LoginModule)
            },
            {
                path: 'change-password',
                loadChildren: () => import('@modules/change-password/change-password.module').then(m => m.ChangePasswordModule)
            }
        ]
    },
    {
        path: 'home',
        loadChildren: () => import('@modules/home/home.mobile.module').then(m => m.HomeMobileModule)
    },
    {
        path: 'sso_callback',
        loadChildren: () => import('@modules/sso-callback/sso-callback.module').then(m => m.SsoCallbackModule)
    },
    {
        path: 'client-login',
        loadChildren: () => import('@modules/client-login/client-login.module').then(m => m.ClientLoginModule)
    },
    {
        path: 'logout',
        loadChildren: () => import('@modules/logout/logout.module').then(m => m.LogoutModule)
    },
    // Not found
    { path: '**', redirectTo: 'login' }
];

